import React from "react";

import SvgPlayCircle from "@uui/PlayCircle";

import { IconButton, IconButtonProps } from "@mui/material";

const PlayVideoButton = ({ sx, ...props }: IconButtonProps) => {
  return (
    <IconButton
      sx={{
        position: "absolute",
        height: "100px",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "#3D3D3DBB",
        "&:hover": {
          bgcolor: "#3D3D3DDD",
        },
        ...sx,
      }}
      {...props}
    >
      <SvgPlayCircle
        strokeWidth={1}
        sx={{
          color: "#FFF",
          width: "55px",
          height: "55px",
          "& path": {
            strokeWidth: 1,
          },
        }}
      />
    </IconButton>
  );
};

export default PlayVideoButton;
